import { jsx as l, jsxs as t } from "react/jsx-runtime";
import "react";
var p = (a) => /* @__PURE__ */ t("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...a,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "M31.304 20.217H8.696c0 1.561 1.36 2.827 2.92 2.827h-.094a2.826 2.826 0 0 0 2.826 2.826 2.826 2.826 0 0 0 2.826 2.826h5.652a2.826 2.826 0 0 0 2.826-2.826 2.826 2.826 0 0 0 2.826-2.826h-.094c1.56 0 2.92-1.266 2.92-2.827Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M27.826 16.522a7.826 7.826 0 0 1-15.652 0"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "m25.978 16.522-2.443 1.149 1.3 2.365-2.652-.507-.336 2.68L20 20.237l-1.848 1.97-.336-2.68-2.652.508 1.3-2.365-2.442-1.15 2.443-1.148-1.3-2.366 2.651.508.337-2.68L20 12.805l1.848-1.97.335 2.68 2.653-.508-1.3 2.366 2.442 1.149Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "m29.781 20-3.996 1.88 2.128 3.87-4.34-.83-.55 4.384L20 26.08l-3.023 3.224-.55-4.384-4.34.83 2.129-3.87L10.219 20l3.997-1.88-2.128-3.87 4.339.83.55-4.384L20 13.92l3.023-3.224.55 4.384 4.34-.83-2.128 3.87L29.78 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M20 26.087a6.087 6.087 0 1 0 0-12.174 6.087 6.087 0 0 0 0 12.174Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "M16.956 20a4.39 4.39 0 0 0-.434.022c.006.843.31 1.614.814 2.214a6.102 6.102 0 0 1 1.176-1.947A4.326 4.326 0 0 0 16.956 20Zm1.874 3.276a3.468 3.468 0 0 0 2.34 0 4.35 4.35 0 0 0-1.17-2.03 4.35 4.35 0 0 0-1.17 2.03Zm4.182-5.015a3.476 3.476 0 0 0-6.024 0A6.047 6.047 0 0 1 20 19.08a6.047 6.047 0 0 1 3.012-.819Zm-1.524 2.028a6.1 6.1 0 0 1 1.176 1.947c.503-.6.808-1.371.814-2.214a4.362 4.362 0 0 0-1.99.267Z"
    })
  ]
});
export {
  p as default
};
